module.exports = __webpack_public_path__ + "img/no-units.26ff393c.svg";